import {JobAction, LOAD_JOB, LOAD_JOB_FAIL, LOAD_JOB_SUCCESS, LoadJobFail, LoadJobSuccess} from '../actions';
import {LoadJob} from "../actions/job.action";

export interface IWebsiteJobState {
  websiteId: number;
  entities: {[id: string]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IJobState {
  entities: {[websiteId: number]: IWebsiteJobState};
}

export const initialState: IJobState = {
  entities: {}
};

export function reducer(state: IJobState = initialState, action: JobAction): IJobState {
  let payload: any;

  switch (action.type) {
    case LOAD_JOB:
      payload = (<LoadJob>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_JOB_SUCCESS:
      payload = (<LoadJobSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_JOB_FAIL:
      payload = (<LoadJobFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
